import {v4 as uuid } from 'uuid';
import {
    createImage,
    getImageProps,
} from '../../../../commons/images';

async function updateWidgetSettings (widget) {
    console.log('appStore.updateWidgetSettings(): current widget ', this.widget);
    if (widget.customCssUrl) {
        this.attachCustomCSS(widget.customCssUrl);
    }

    if (this.widget) {
        let imageProps = {};
        if (widget.logo) {
            const image = await createImage(widget.logo);
            imageProps = getImageProps(image);
        }

        this.widget = {
            ...this.widget,
            ...widget,
            ...imageProps,
        };
    }


    if (widget.language) {
        await this.env.languageStore.getTranslations();
    }
    this.observed.widget = uuid();
}

export default updateWidgetSettings;
